"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _newId = require("../helpers/newId");

var _newId2 = _interopRequireDefault(_newId);

var _tokens = require("../helpers/tokens.json");

var _tokens2 = _interopRequireDefault(_tokens);

require("./Icon.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Icon = function Icon(_ref) {
  var ariaText = _ref.ariaText,
      className = _ref.className,
      color = _ref.color,
      rotate = _ref.rotate,
      size = _ref.size,
      type = _ref.type,
      moreProps = _objectWithoutProperties(_ref, ["ariaText", "className", "color", "rotate", "size", "type"]);

  var ariaId = void 0;
  if (ariaText) ariaId = (0, _newId2.default)("icon");

  var classes = (0, _classnames2.default)(className, "aclui-icon", "acl-i-" + type);

  return _react2.default.createElement(
    "i",
    _extends({
      "aria-hidden": !ariaText,
      "aria-labelledby": ariaId,
      className: classes,
      role: "img",
      style: {
        color: color,
        fontSize: size + "px",
        transform: "rotate(" + rotate + "deg)"
      }
    }, moreProps),
    ariaText && _react2.default.createElement(
      "span",
      { id: ariaId, className: "aclui-icon__aria-label" },
      ariaText
    )
  );
};

Icon.propTypes = {
  ariaText: _propTypes2.default.string,
  className: _propTypes2.default.string,
  color: _propTypes2.default.string,
  rotate: _propTypes2.default.number,
  size: _propTypes2.default.number,
  type: _propTypes2.default.string.isRequired
};

Icon.defaultProps = {
  ariaText: null,
  color: _tokens2.default.color.black,
  rotate: 0,
  size: 16
};

exports.default = Icon;